import React from "react";

import { Pagination } from "../../../components/ui/Pagination";
import { Table } from "../../../components/ui/Table";

import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import { SORTABLE_COLUMN_KEYS } from "../constants";
import { WhatsAppModal } from "../Modals/WhatsAppModal";
import { formatTableColumns, getCrmPetTableColumns } from "./columns";
import { PetRow } from "./PetRow";

export function CrmPetTable() {
  const CCrmPet = CrmPetController();
  const config = useCrmPet((st) => st.data.config);
  const isWaiting = useCrmPet((st) => st.data.isWaiting);
  const pagination = useCrmPet((st) => st.data.pagination);
  const customers = useCrmPet((st) => st.data.customers);
  const facets = useCrmPet((st) => st.data.facets);
  const filter = useCrmPet((st) => st.data.filter);
  const sort = useCrmPet((st) => st.data.sort);
  const selectedCustomerKey = useCrmPet((st) => st.data.selectedCustomerKey);

  const pageCustomers = customers[pagination.page] || [];
  const columns = getCrmPetTableColumns(filter.rule, facets);
  const tableColumns = formatTableColumns(columns);
  const tableMinWidth = Math.max(980, columns.length * 118);
  const selectedCustomer = Object.values(customers)
    .flat()
    .find((customer) => customer.customerKey === selectedCustomerKey);

  return (
    <>
      <div id="crm-pet-opportunities-table" className="w-full overflow-x-auto pb-1">
        <div style={{ minWidth: tableMinWidth }}>
          <Table.Root name={CCrmPet.tableName}>
            <Table.Header
              columns={tableColumns}
              sortableConfig={{
                sortBy: sort.sortBy,
                sortOrder: sort.sortOrder,
                onSort: CCrmPet.handleSortColumn,
                columnKeys: SORTABLE_COLUMN_KEYS,
              }}
            />
            <Table.Content isLoading={isWaiting} loadingLine={10}>
              {pagination.totalDocuments === 0 && !isWaiting ? (
                <div style={{ textAlign: "center", padding: "60px 0", color: "#aaa", fontSize: 14 }}>
                  Nenhuma oportunidade encontrada para os filtros selecionados.
                </div>
              ) : (
                pageCustomers.map((customer) => (
                  <PetRow
                    key={customer.rowKey}
                    customer={customer}
                    columns={columns}
                  />
                ))
              )}
            </Table.Content>

            <Pagination.Root
              name={CCrmPet.paginationName}
              totalPages={Math.max(0, pagination.totalPages - 1)}
              currentPage={pagination.page}
              onChange={(page) => CCrmPet.setPage(page)}
            >
              <Pagination.Back />
              <Pagination.Pages />
              <Pagination.Forward />
            </Pagination.Root>
          </Table.Root>
        </div>
      </div>

      {
        selectedCustomer && (
          <WhatsAppModal
            customer={selectedCustomer}
            config={config}
            onClose={CCrmPet.closeWhatsApp}
          />
        )
      }
    </>
  );
}
